var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVisibilityOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.704q1.745 0 3.021 1.275t1.275 3.021-1.275 3.021-3.021 1.275-3.021-1.275-1.275-3.021 1.275-3.021 3.021-1.275zM15.75 19.182q2.953 0 5.068-2.114t2.114-5.068-2.114-5.068-5.068-2.114-5.068 2.114-2.114 5.068 2.114 5.068 5.068 2.114zM15.75 1.26q5.303 0 9.599 2.953t6.175 7.786q-1.879 4.833-6.175 7.786t-9.599 2.953-9.598-2.953-6.175-7.786q1.879-4.833 6.175-7.786t9.598-2.953z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibilityOn);
export default __webpack_public_path__ + "static/media/icon-visibility-on.54a700f6e32c121794a6d28ffd2faf22.svg";
export { ForwardRef as ReactComponent };